import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Taxextension = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Tax Extension Filing</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Extend Your Tax Deadlines with Confidence
          </h1>
          <p className="tax-section-description">
            Tax season can feel overwhelming, especially if you’re still
            gathering documents or managing multiple financial priorities. A tax
            extension provides valuable extra time to prepare your return
            accurately. At Litax , we make the process simple,
            ensuring you remain compliant while avoiding unnecessary penalties.
          </p>

          <h2 className="tax-subheading">What a Tax Extension Really Means</h2>
          <p className="tax-section-description">
            Filing for an extension extends the <strong>deadline to file</strong>{" "}
            your return—but it does <strong>not extend the deadline to pay</strong>{" "}
            your taxes. You must estimate and pay any taxes owed by the original
            due date to avoid penalties and interest. Our experts help you
            calculate accurate estimates so you can file stress-free.
          </p>

          <h2 className="tax-subheading">For Individual Taxpayers</h2>
          <p className="tax-section-description">
            We assist individuals in filing{" "}
            <strong>Form 4868 (Application for Automatic Extension)</strong>,
            which typically extends the deadline to October 15. With our help,
            you’ll:
          </p>
          <ul className="tax-section-description">
            <li>
              <strong>Check Eligibility:</strong> Most individuals qualify, but
              we review your case to confirm compliance.
            </li>
            <li>
              <strong>Understand Deadlines:</strong> Get a clear timeline for
              filing and payments to avoid surprises.
            </li>
            <li>
              <strong>Make Smart Estimates:</strong> We calculate your estimated
              liability so you can make payments confidently.
            </li>
          </ul>

          <h2 className="tax-subheading">For Businesses</h2>
          <p className="tax-section-description">
            Whether you operate a sole proprietorship, partnership, or
            corporation, we guide you through{" "}
            <strong>Form 7004 (Automatic Extension for Business Returns)</strong>{" "}
            and ensure you meet IRS requirements. Our services include:
          </p>
          <ul className="tax-section-description">
            <li>
              Preparing and filing the correct extension forms for your business
              entity.
            </li>
            <li>
              Estimating business tax obligations to minimize penalties and
              interest.
            </li>
            <li>
              Providing proactive advice to align your extension with long-term
              tax planning.
            </li>
          </ul>

          <h2 className="tax-subheading">Common Mistakes We Help You Avoid</h2>
          <ul className="tax-section-description">
            <li>
              Believing an extension delays tax <em>payments</em> (it doesn’t).
            </li>
            <li>
              Missing the October deadline after filing an extension.
            </li>
            <li>
              Underestimating tax liability and facing penalties.
            </li>
            <li>
              Filing the wrong extension form for your entity type.
            </li>
          </ul>

          <h2 className="tax-subheading">Why Choose Litax ?</h2>
          <p className="tax-section-description">
            With years of expertise in U.S. tax compliance, we handle
            extensions for both individuals and businesses quickly and
            accurately. Our personalized approach ensures you never miss a
            deadline, your payments are calculated correctly, and you gain the
            breathing room you need to file confidently.
          </p>

          <p className="tax-section-description">
            Don’t let deadlines cause stress—file your tax extension with
            Litax  today and get peace of mind knowing you’re
            protected and compliant.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Taxextension;
